import { telemetry } from './lib/telemetry';

telemetry.init();
